import {createSlice, Draft, PayloadAction} from "@reduxjs/toolkit";
import {createMultiOptions} from "../../../../utils/createOptions";
import {IProjestListOptions} from "../../../../types/projectsInterface";

const initialState: any = {
    count: 0,
    data: [],
    projects: [],
    currentProject: {},
    pages: 1,
    totalEmps: 0,
    totalPoses: 0,
    totalRoutes: 0,
    limit: JSON.parse(localStorage.getItem("pageLimit") as string) || 10,
    projectsInputValues: {
        managers: [],
    },
};

export const consolidatedBudgetSlice = createSlice({
                                                       name: "consolidatedBudget",
                                                       initialState,
                                                       reducers: {
                                                           reducerGetConsolidatedBudgetProjects: (state: Draft<any>, action: PayloadAction<any>) => {
                                                               state.count = action.payload.data.count;
                                                               state.data = action.payload.data.data;
                                                               state.pages = action.payload.data.pages;
                                                               state.totalEmps = action.payload.data.totalEmps;
                                                               state.totalPoses = action.payload.data.totalPoses;
                                                               state.totalRoutes = action.payload.data.totalRoutes;
                                                               state.projects = action.payload.data.data.map((el: any) => el.project);
                                                               state.projectsOptions = action.payload.data.data.map((el: any) => ({
                                                                   label: el.project.name,
                                                                   value: el.project.id,
                                                               }));
                                                               const temp: any = {};
                                                               action.payload.data.data.map(
                                                                   (el: any) => (temp[el.project.id] = el.project.name)
                                                               );
                                                               state.projectsById = temp;
                                                               state.checkboxes = action.payload.data?.data?.reduce(
                                                                   (acc: boolean[], p: IProjestListOptions) => {
                                                                       const projectId = p.project?.id;
                                                                       acc[projectId] = false;
                                                                       return acc;
                                                                   },
                                                                   {}
                                                               );
                                                           },
                                                           reducerGetConsolidatedBudgetFilters: (
                                                               state: Draft<any>,
                                                               action: PayloadAction<any>
                                                           ) => {
                                                               state.projectsFilters = action.payload;
                                                               state.managersOptions = createMultiOptions(action.payload.managers);
                                                           },
                                                           reducerConsolidatedBudgetInputValues: (
                                                               state: Draft<any>,
                                                               action: PayloadAction<any>
                                                           ) => {
                                                               state.projectsInputValues = action.payload;
                                                           },
                                                           reducerSetCurrentConsolidatedBudget: (
                                                               state: Draft<any>,
                                                               action: PayloadAction<any>
                                                           ) => {
                                                               state.currentProject = action.payload;
                                                           },
                                                           reducerConsolidatedBudgetClearValues: () => {
                                                               return initialState;
                                                           },
                                                           reducerConsolidatedBudgetStatus: (
                                                               state: Draft<any>,
                                                               action: PayloadAction<any>
                                                           ) => {
                                                               state.status = action.payload;
                                                           },
                                                           reducerSelectedProjectsId: (
                                                               state: Draft<any>,
                                                               action: PayloadAction<any>
                                                           ) => {
                                                               state.selectedProjectsId = action.payload;
                                                           },
                                                           reducerSelectedProjects: (
                                                               state: Draft<any>,
                                                               action: PayloadAction<any>
                                                           ) => {
                                                               state.selectedProjects = action.payload;
                                                           },
                                                       },
                                                   });

export const {
    reducerGetConsolidatedBudgetProjects,
    reducerGetConsolidatedBudgetFilters,
    reducerConsolidatedBudgetInputValues,
    reducerSetCurrentConsolidatedBudget,
    reducerConsolidatedBudgetClearValues,
    reducerSelectedProjectsId,
    reducerSelectedProjects,
    reducerConsolidatedBudgetStatus
} = consolidatedBudgetSlice.actions;

export default consolidatedBudgetSlice.reducer;